import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as documentWizardStyles from '../../document-wizard-modal.styles';
import * as docErrorStyles from './document-alert.styles';

const sc = { ...documentWizardStyles, ...docErrorStyles };

const errorText = {
  duplicate: {
    heading: <>This Document Appears to Be a Duplicate</>,
    body: <>Please upload a different document.</>
  },
  screenshot: {
    heading: <>This Looks Like a Screenshot</>,
    body: <>Unfortunately we can not use screenshots to validate information. Please upload an image of a valid document. The most common ways are to download an image from the institution&apos;s website or to take a photo of a paper document.</>
  }
};

const DocumentAlert = ({ errorType }) => {
  const text = errorText[errorType];
  const [documentIsValid, setDocumentIsValid] = useState(false);

  useEffect(() => () => setDocumentIsValid(false), []);

  return (
    <sc.DocumentErrorWrapper>
      <sc.DocumentErrorMessageWrapper>
        <sc.AlertIcon red={errorType === 'duplicate' ? 'true' : undefined} />
        <sc.DocumentErrorHeading>{text?.heading}</sc.DocumentErrorHeading>
        <sc.DocumentErrorTextBody>{text?.body}</sc.DocumentErrorTextBody>
      </sc.DocumentErrorMessageWrapper>
      {errorType !== 'duplicate' &&
        <sc.FormCheckbox
          name='documentIsValid'
          label='Sometimes we get it wrong. Check this box if we got this wrong and this isn’t a screenshot.'
          onChange={() => setDocumentIsValid(!documentIsValid)}
          value={documentIsValid}
        />
      }
    </sc.DocumentErrorWrapper>
  );
}

DocumentAlert.propTypes = {
  errorType: PropTypes.string
};

DocumentAlert.defaultProps = {
  errorType: 'duplicate'
};

export default DocumentAlert;
